var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file Cascader 级联选择器
 * @author (zhuwanying02) if any problem, please call me.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash-es';
import { classPrefix, EleResize } from '../../common/util';
/* global getComputedStyle */
import Input from '../Input';
import DropdownBase from '../Dropdown/DropdownBase';
import PopperWrap from '../PopperWrap';
import './Cascader.less';

/**
 * 参数说明
 * optionData                   必需，可选项数据源，对象数组
 * getValue                     必需，选择完成后的回调，(value) => void
 * onHandleChange               form专用
 * placeHolder                  非必需，输入框占位文本，字符串
 * width                        非必需，输入框宽度（默认400px），字符串或数据
 * value                        非必需，默认选中项，string
 * dropdownItemWidth            非必需，单个下拉框宽度（默认120px），字符串或数据
 * className                    非必需，组件根元素上传入自定义类，字符串
 * single                       可选，是否可以选择非叶子节点项
 * classPrefix                  可选，类名前缀
 * zIndex                       可选，下拉的zIndx
 * preventOverflowEnabled       非必需,下拉是否受overflow碰撞影响
 * popupOnBody                 可选,下拉是否挂在body上
 */

var Cascader = function (_Component) {
    _inherits(Cascader, _Component);

    function Cascader(props) {
        _classCallCheck(this, Cascader);

        var _this = _possibleConstructorReturn(this, (Cascader.__proto__ || Object.getPrototypeOf(Cascader)).call(this, props));

        _this.resizeHandler = function () {
            var width = getComputedStyle(_this.dpContainer).width;
            _this.setState({
                inputWidth: parseFloat(width)
            });
        };

        _this.getDropdownItemWidths = function () {
            if (!_this.props.responsive) {
                return null;
            }
            var dropdownItemWidth = _this.props.dropdownItemWidth;
            if (_.isArray(dropdownItemWidth)) {
                return dropdownItemWidth.reduce(function (pre, nev) {
                    return pre + nev;
                }, 0);
            } else {
                return 3 * parseFloat(dropdownItemWidth);
            }
        };

        _this.onIconClick = _this.onIconClick.bind(_this);
        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
        _this.handleDropdownClickChange = _this.handleDropdownClickChange.bind(_this);
        _this.handleDropdownMouseEnter = _this.handleDropdownMouseEnter.bind(_this);
        _this.onCloseByWindow = _this.onCloseByWindow.bind(_this);
        _this.toggleDropdownVisible = _this.toggleDropdownVisible.bind(_this);

        _this.optionDataInfo = {}; // 用于存放处理后的OptionData信息
        _this.handleOptionData(props.optionData);

        _this.state = {
            isShowPanel: false,
            isShowClearIcon: false,
            dropdownItems: [],
            optionSelectValue: [],
            inputWidth: 400
        };
        _this.FORM_NEED_VALIDATE = 0;
        _this.FORM_NO_NEED_VALIDATE = 1;
        return _this;
    }

    _createClass(Cascader, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.updateOptionSelectValue(this.props, this.FORM_NO_NEED_VALIDATE, function () {
                _this2.updateDropdownItemsProps(_this2.props);
            });

            if (!this.props.responsive) {
                return;
            }
            this.resizeHandler();
            EleResize.on(this.dpContainer, this.resizeHandler);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.formCallback(this.props.value, this.FORM_NO_NEED_VALIDATE, true);

            if (!this.props.responsive) {
                return;
            }
            EleResize.off(this.dpContainer, this.resizeHandler);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this3 = this;

            var value = nextProps.value,
                optionData = nextProps.optionData;


            if (!_.isEqual(optionData, this.props.optionData)) {
                this.optionDataInfo = {};
                this.handleOptionData(optionData);
                this.updateOptionSelectValue(nextProps, this.FORM_NEED_VALIDATE, function () {
                    _this3.updateDropdownItemsProps(nextProps);
                });
            }

            if (value !== this.props.value) {
                this.updateOptionSelectValue(nextProps, this.FORM_NEED_VALIDATE, function () {
                    _this3.updateDropdownItemsProps(nextProps);
                });
            }
        }
    }, {
        key: 'updateOptionSelectValue',
        value: function updateOptionSelectValue(props, needValidate, callback) {
            var custom = props.custom,
                value = props.value;

            var optionDataInfo = this.optionDataInfo;

            var pathItems = [];
            var pathValue = [];

            if (value && optionDataInfo[value]) {
                pathItems = optionDataInfo[value].pathItems;
            }
            if (custom && pathItems.length === 0) {
                var lastValue = pathValue[pathValue.length - 1];
                if (lastValue) {
                    pathItems = optionDataInfo[lastValue].pathItems;
                }
            }
            this.formCallback(value, needValidate);

            var selectedValues = pathItems.map(function (v) {
                return v.value;
            });
            var optionSelectValue = _.assign([], selectedValues).reverse();

            this.setState({
                optionSelectValue: optionSelectValue
            }, callback);
        }
    }, {
        key: 'formCallback',
        value: function formCallback(pathItems) {
            var needValidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.FORM_NEED_VALIDATE;
            var isDelete = arguments[2];
            var _props = this.props,
                formFlag = _props.formFlag,
                increment = _props.increment,
                name = _props.name,
                onHandleChange = _props.onHandleChange;

            if (onHandleChange && formFlag && _.isFunction(onHandleChange)) {
                onHandleChange({
                    name: name,
                    value: pathItems
                }, this, needValidate, increment, isDelete);
            }
        }

        // === 获取第一项作为默认项 ===

    }, {
        key: 'getFirstItemAsDefault',
        value: function getFirstItemAsDefault(props) {
            var optionData = props.optionData;
            var optionSelectValue = this.recursiveGetFirstDefault(optionData, []);
            return optionSelectValue;
        }
    }, {
        key: 'recursiveGetFirstDefault',
        value: function recursiveGetFirstDefault(data, arr) {
            if (data[0]) {
                arr.push(data[0].value);

                if (data[0].children) {
                    this.recursiveGetFirstDefault(data[0].children, arr);
                }
            }
            return arr;
        } // === 获取第一项作为默认项 end ===

    }, {
        key: 'updateDropdownItemsProps',
        value: function updateDropdownItemsProps(props) {
            var optionData = props.optionData,
                dropdownItemWidth = props.dropdownItemWidth,
                single = props.single;

            var optionSelectValue = this.state.optionSelectValue;
            var optionDataInfo = this.optionDataInfo;

            if (optionSelectValue.length === 0) {
                var dropdownItemsProps = [{
                    optionData: optionData,
                    width: _.isArray(dropdownItemWidth) ? dropdownItemWidth[0] : dropdownItemWidth,
                    single: single
                }];

                this.setState({
                    dropdownItemsProps: dropdownItemsProps
                });
            } else {
                var lastValue = optionSelectValue[optionSelectValue.length - 1];
                var _optionDataInfo$lastV = optionDataInfo[lastValue],
                    _optionData = _optionDataInfo$lastV.optionData,
                    parent = _optionDataInfo$lastV.parent;


                var _dropdownItemsProps = _optionData.map(function (item, index) {
                    var selectValue = '';

                    if (optionSelectValue[index]) {
                        selectValue = optionSelectValue[index];
                    } else if (parent.length > 0 && parent[index]) {
                        selectValue = parent[index].value;
                    }

                    return {
                        optionData: item,
                        width: _.isArray(dropdownItemWidth) ? dropdownItemWidth[index] : dropdownItemWidth,
                        value: selectValue, // 高亮
                        single: single
                    };
                });
                this.setState({
                    dropdownItemsProps: _dropdownItemsProps
                });
            }
        }

        // === 处理optionData数据，得到有用信息 ===

    }, {
        key: 'getParentOptionItem',
        value: function getParentOptionItem(children, parent) {
            if (!children || children.length === 0) {
                return;
            }

            for (var i = 0, len = children.length; i < len; i++) {
                var child = children[i];

                if (!child || !child.value) {
                    break;
                }

                this.optionDataInfo[child.value] = {
                    self: child, // 记录自身数据
                    parent: parent, // 设置select value用到
                    pathItems: [], // 展示label用到
                    optionData: [] // 渲染dropdown items用到
                };
                if (child.children) {
                    this.getParentOptionItem(child.children, child);
                }
            }
        }
    }, {
        key: 'handleOptionData',
        value: function handleOptionData(optionData) {
            this.getParentOptionItem(optionData);

            for (var i in this.optionDataInfo) {
                if (this.optionDataInfo.hasOwnProperty(i)) {
                    var itemInfo = this.optionDataInfo[i];

                    itemInfo.pathItems.push({
                        value: itemInfo.self.value,
                        name: itemInfo.self.name
                    });
                    if (itemInfo.self.children) {
                        itemInfo.optionData.push(itemInfo.self.children);
                    }
                    if (itemInfo.parent) {
                        this.getAbsolutePathOptionItem(i, itemInfo.parent);
                    }
                }
            }

            for (var _i in this.optionDataInfo) {
                if (this.optionDataInfo.hasOwnProperty(_i)) {
                    var _itemInfo = this.optionDataInfo[_i];

                    _itemInfo.optionData.reverse().unshift(optionData);
                    _itemInfo.parent = _.assign([], _itemInfo.pathItems); // 只传值，不关联
                    _itemInfo.parent.reverse().pop();
                }
            }
        }
    }, {
        key: 'getAbsolutePathOptionItem',
        value: function getAbsolutePathOptionItem(value, parent) {
            this.optionDataInfo[value].pathItems.push({
                value: parent.value,
                name: parent.name
            });

            if (parent.children) {
                this.optionDataInfo[value].optionData.push(parent.children);
            }

            if (this.optionDataInfo[parent.value].parent) {
                this.getAbsolutePathOptionItem(value, this.optionDataInfo[parent.value].parent);
            }
        } // === 处理optionData数据  end ===

    }, {
        key: 'handleDropdownClickChange',
        value: function handleDropdownClickChange(e) {
            var value = e.result.value;
            if (!value) {
                return;
            }
            var pathItems = this.optionDataInfo[value].pathItems;
            var pathItemsReverse = _.assign([], pathItems).reverse();
            var optionSelectValue = pathItemsReverse.map(function (v) {
                return v.value;
            });

            this.setState({
                isShowPanel: false
            });

            var _props2 = this.props,
                getValue = _props2.getValue,
                name = _props2.name;

            if (getValue && _.isFunction(getValue)) {
                getValue({
                    name: name,
                    value: optionSelectValue[optionSelectValue.length - 1]
                });
            }
        }
    }, {
        key: 'handleDropdownMouseEnter',
        value: function handleDropdownMouseEnter(e) {
            var value = e.value;
            if (!value) {
                return;
            }
            var _props3 = this.props,
                dropdownItemWidth = _props3.dropdownItemWidth,
                single = _props3.single;


            if (this.optionDataInfo[value]) {
                var _optionDataInfo$value = this.optionDataInfo[value],
                    optionData = _optionDataInfo$value.optionData,
                    parent = _optionDataInfo$value.parent;

                var dropdownItemsProps = optionData.map(function (item, index) {
                    var selectValue = '';

                    if (parent.length > 0 && parent[index]) {
                        selectValue = parent[index].value;
                    }
                    // hover 事件相比click, 新增了optionHoverd属性, 修改了value的设置方式
                    return {
                        optionData: item,
                        width: _.isArray(dropdownItemWidth) ? dropdownItemWidth[index] : dropdownItemWidth,
                        value: selectValue,
                        optionHoverd: value,
                        single: single
                    };
                });

                this.setState({
                    dropdownItemsProps: dropdownItemsProps
                });
            }
        }
    }, {
        key: 'onCloseByWindow',
        value: function onCloseByWindow() {
            this.setState({
                isShowPanel: false
            });
        }
    }, {
        key: 'toggleDropdownVisible',
        value: function toggleDropdownVisible() {
            var _this4 = this;

            if (this.props.disabled) {
                return;
            }
            this.updateDropdownItemsProps(this.props);
            this.setState({
                isShowPanel: !this.state.isShowPanel
            }, function () {
                if (_this4.state.isShowPanel) {
                    _this4.PopperWrap.update(); // 每次点开下来就重新计算下拉位置
                }
            });
        }
    }, {
        key: 'onIconClick',
        value: function onIconClick(e) {
            if (this.props.disabled) {
                return;
            }

            // 当cascader有值的时候才有清空功能
            if (this.state.optionSelectValue.length > 0) {
                // 没有下拉点击清空不会出现下拉
                e.stopPropagation();

                // 更换图标
                this.setState({
                    isShowClearIcon: false
                });

                var _props4 = this.props,
                    getValue = _props4.getValue,
                    name = _props4.name;

                if (getValue && _.isFunction(getValue)) {
                    getValue({
                        name: name,
                        value: ''
                    });
                }
            }
        }
    }, {
        key: 'onMouseEnter',
        value: function onMouseEnter() {
            if (this.props.disabled) {
                return;
            }
            this.state.optionSelectValue.length > 0 && this.setState({
                isShowClearIcon: true
            });
        }
    }, {
        key: 'onMouseLeave',
        value: function onMouseLeave() {
            if (this.props.disabled) {
                return;
            }
            this.setState({
                isShowClearIcon: false
            });
        }
    }, {
        key: 'getDropdownItems',
        value: function getDropdownItems() {
            var _this5 = this;

            var dropdownItemsProps = this.state.dropdownItemsProps;
            var classPrefix = this.props.classPrefix;
            if (dropdownItemsProps && dropdownItemsProps.length > 0) {
                return React.createElement(
                    'div',
                    { className: classPrefix + '-cascader-dropdown' },
                    dropdownItemsProps.map(function (item, index) {
                        return React.createElement(DropdownBase, _extends({
                            key: 'drop_' + index,
                            onHandleChange: _this5.handleDropdownClickChange,
                            onHandleMouseEnter: _this5.handleDropdownMouseEnter
                        }, item));
                    })
                );
            }
            return null;
        }
    }, {
        key: 'getLabel',
        value: function getLabel() {
            var _this6 = this,
                _classnames,
                _classnames2,
                _classnames3,
                _classnames4;

            var _props5 = this.props,
                label = _props5.label,
                width = _props5.width,
                placeHolder = _props5.placeHolder,
                custom = _props5.custom,
                noWarning = _props5.noWarning,
                validate = _props5.validate,
                classPrefix = _props5.classPrefix,
                disabled = _props5.disabled,
                responsive = _props5.responsive;
            var _state = this.state,
                isShowPanel = _state.isShowPanel,
                isShowClearIcon = _state.isShowClearIcon,
                optionSelectValue = _state.optionSelectValue;


            var optionSelectNames = optionSelectValue.map(function (v) {
                if (_this6.optionDataInfo[v]) {
                    return _this6.optionDataInfo[v].self.name;
                }
                return '';
            });

            var cascaderIcon = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-cascader-arrow', !isShowClearIcon), _defineProperty(_classnames, classPrefix + '-cascader-arrow-up', !isShowClearIcon && isShowPanel), _defineProperty(_classnames, classPrefix + '-cascader-clear', isShowClearIcon), _classnames));
            var customCascaderArrow = classnames((_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-cascader-arrow-custom', true), _defineProperty(_classnames2, classPrefix + '-cascader-arrow-up-custom', isShowPanel), _classnames2));

            var labelClass = classnames((_classnames3 = {}, _defineProperty(_classnames3, classPrefix + '-cascader-label', true), _defineProperty(_classnames3, classPrefix + '-cascader-label-withlabel', label), _defineProperty(_classnames3, classPrefix + '-cascader-label-custom', custom), _classnames3));

            var inputClass = classnames((_classnames4 = {}, _defineProperty(_classnames4, classPrefix + '-cascader-input', true), _defineProperty(_classnames4, classPrefix + '-cascader-input-active', isShowPanel), _classnames4));

            var inputProps = {
                width: responsive ? this.state.inputWidth : width,
                validate: validate,
                placeHolder: optionSelectValue && optionSelectValue.length > 0 ? '' : placeHolder,
                className: inputClass,
                noWarning: noWarning,
                readOnly: true,
                value: optionSelectNames.join(' / '),
                disabled: disabled,
                responsive: responsive
            };

            var iconProps = {
                className: cascaderIcon,
                onMouseEnter: this.onMouseEnter,
                onClick: this.onIconClick,
                onMouseLeave: this.onMouseLeave
            };
            if (custom) {
                return React.createElement(
                    'label',
                    { className: labelClass },
                    React.createElement(
                        'span',
                        null,
                        optionSelectNames.join(' / ')
                    ),
                    React.createElement('div', { className: customCascaderArrow })
                );
            }
            return [React.createElement(Input, _extends({ key: 'input' }, inputProps)), React.createElement('label', _extends({ key: 'icon' }, iconProps))];
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames5,
                _classnames6,
                _this7 = this,
                _classnames7;

            var _props6 = this.props,
                label = _props6.label,
                tips = _props6.tips,
                className = _props6.className,
                custom = _props6.custom,
                classPrefix = _props6.classPrefix,
                noWarning = _props6.noWarning,
                validate = _props6.validate,
                zIndex = _props6.zIndex,
                preventOverflowEnabled = _props6.preventOverflowEnabled,
                popupOnBody = _props6.popupOnBody,
                responsive = _props6.responsive;


            var cx = classnames(className, (_classnames5 = {}, _defineProperty(_classnames5, classPrefix + '-cascader-root', true), _defineProperty(_classnames5, 'responsive', responsive), _classnames5));
            var hasWarning = -1;
            var cascaderClass = classnames((_classnames6 = {}, _defineProperty(_classnames6, classPrefix + '-cascader', true), _defineProperty(_classnames6, classPrefix + '-cascader-custom', custom), _defineProperty(_classnames6, classPrefix + '-cascader-withlabel', label), _defineProperty(_classnames6, 'warning-border', !noWarning && validate && validate.ret === hasWarning), _classnames6));

            var dropdownItemWidths = this.getDropdownItemWidths();

            return React.createElement(
                'div',
                { className: cx },
                label && React.createElement(
                    'div',
                    { className: classPrefix + '-form-label' },
                    label
                ),
                React.createElement(PopperWrap, {
                    ref: function ref(el) {
                        _this7.PopperWrap = el;
                    },
                    containerNode: React.createElement(
                        'div',
                        {
                            className: cascaderClass,
                            onClick: this.toggleDropdownVisible,
                            ref: function ref(el) {
                                _this7.dpContainer = el;
                            }
                        },
                        this.getLabel()
                    ),
                    popupNode: this.getDropdownItems(),
                    popupNodeClassName: classnames((_classnames7 = {}, _defineProperty(_classnames7, classPrefix + '-cascader-panel', true), _defineProperty(_classnames7, classPrefix + '-cascader-custom-panel', custom), _classnames7)),
                    onBodyClick: this.onCloseByWindow,
                    isShowPopup: this.state.isShowPanel,
                    popupNodeZIndex: zIndex,
                    preventOverflowEnabled: preventOverflowEnabled,
                    popupOnBody: popupOnBody,
                    popupNodeWidth: dropdownItemWidths
                }),
                tips && React.createElement(
                    'div',
                    { className: classPrefix + '-form-tips' },
                    tips
                )
            );
        }
    }]);

    return Cascader;
}(Component);

export default Cascader;


Cascader.defaultProps = {
    optionData: [],
    custom: false,
    width: 400,
    single: false,
    classPrefix: classPrefix,
    value: '',
    preventOverflowEnabled: true,
    placeHolder: '请选择',
    dropdownItemWidth: 120
};

Cascader.propTypes = {
    optionData: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
    })).isRequired,
    onHandleChange: PropTypes.func,
    className: PropTypes.string,
    placeHolder: PropTypes.string,
    value: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dropdownItemWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
    custom: PropTypes.bool,
    single: PropTypes.bool,
    formFlag: PropTypes.bool,
    increment: PropTypes.string,
    name: PropTypes.string,
    getValue: PropTypes.func,
    label: PropTypes.node,
    tips: PropTypes.node,
    star: PropTypes.bool,
    noWarning: PropTypes.bool,
    validate: PropTypes.any,
    classPrefix: PropTypes.string,
    zIndex: PropTypes.number,
    preventOverflowEnabled: PropTypes.bool,
    popupOnBody: PropTypes.bool,
    disabled: PropTypes.bool,
    responsive: PropTypes.bool
};